import React from 'react';
import { Box, Typography, Stack, Chip } from '@mui/material';
import PsychologyIcon from '@mui/icons-material/Psychology';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { dashboardPaperSx } from '../DashboardPanel';

const StepChip = ({ step, label, icon: Icon }) => (
    <Chip
        icon={<Icon sx={{ fontSize: '16px !important' }} />}
        label={
            <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                <Box
                    component="span"
                    sx={{
                        width: 18,
                        height: 18,
                        borderRadius: '50%',
                        bgcolor: 'primary.main',
                        color: 'primary.contrastText',
                        fontSize: '0.65rem',
                        fontWeight: 700,
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {step}
                </Box>
                {label}
            </Box>
        }
        sx={{
            height: 36,
            px: 0.5,
            fontWeight: 600,
            bgcolor: 'action.hover',
            border: '1px solid',
            borderColor: 'divider',
            '& .MuiChip-icon': { color: 'primary.main' },
        }}
    />
);

const AsistentHero = ({ t, theme }) => (
    <Box sx={{ ...dashboardPaperSx(theme), mb: 3, p: 3 }}>
        <Stack direction="row" spacing={2} alignItems="flex-start" sx={{ mb: 2 }}>
            <Box
                sx={{
                    width: 52,
                    height: 52,
                    borderRadius: 2,
                    bgcolor: 'primary.main',
                    color: 'primary.contrastText',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                }}
            >
                <PsychologyIcon />
            </Box>
            <Box sx={{ minWidth: 0 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1.2, mb: 0.75 }}>
                    {t('pages.asistent.heroTitle')}
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6, maxWidth: 720 }}>
                    {t('pages.asistent.heroSubtitle')}
                </Typography>
            </Box>
        </Stack>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            <StepChip step={1} label={t('pages.asistent.stepUpload')} icon={CloudUploadIcon} />
            <StepChip step={2} label={t('pages.asistent.stepManage')} icon={FolderOpenIcon} />
            <StepChip step={3} label={t('pages.asistent.stepTest')} icon={ChatBubbleOutlineIcon} />
        </Stack>
    </Box>
);

export default AsistentHero;
